import React from 'react'
import styles from './index.module.scss'
import ResourceItem from './resource-item'
import resources from './resources-data'

const Resources = () => {
    return (
        <section className={styles.resources_section} id="resources">
            <div className={styles.resources_container}>
                <div className={styles.resources_header}>
                    <h2>Resources</h2>
                    <p>Here you can find resources that will help you prepare for the conference.</p>
                </div>
                <div className={styles.resources_content}>
                    {
                        resources.map((resource) => {
                            const text_files = resource.file_download?.map((file) => (
                                file?.text_files
                            ))
                            const audio_files = resource.file_download?.map((file) => (
                                file?.audio_files
                            ))
                            return(
                               <ResourceItem key={resource.id} title={resource.text} image={resource.img} file_download={resource.file_download} text_files={text_files} audio_files={audio_files}/>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default Resources